<div class="w-100">
  @if (!showSearch) {
  <button
    color="primary"
    mat-icon-button
    matTooltip="Buscar"
    (click)="initSearch()"
  >
    <mat-icon class="d-flex" svgIcon="magnify"></mat-icon>
  </button>
  }
  <div class="me-1" [ngClass]="{ 'd-none': showSearch ? false : true }">
    <mat-form-field class="search_inbar">
      @if (!searchControl.value) {
      <mat-icon
        class="action_element d24"
        matSuffix
        matTooltip="Limpiar criterio de búsqueda"
        (click)="clean()"
        svgIcon="magnify-close"
        color="primary"
      ></mat-icon>
      }
      <input
        matInput
        type="search"
        [formControl]="searchControl"
        #searchInput
        placeholder="Teclea para filtrar"
        (search)="onSearch()"
      />
    </mat-form-field>
  </div>
</div>
